import { FunctionComponent, useCallback } from 'react'
import { IconButton } from '../../shared'
import { ConversationHistoryList } from '../ConversationHistoryList'
import { ConversationHistoryDrawerProps } from './ConversationHistoryDrawer.model'
import styles from './ConversationHistoryDrawer.module.scss'

export const ConversationHistoryDrawer: FunctionComponent<ConversationHistoryDrawerProps> = ({
  activeUlid,
  onSelect,
  onNewAnalysis,
  onClose,
}) => {
  const handleDeleted = useCallback(
    (ulid: string) => {
      if (ulid === activeUlid) onNewAnalysis()
    },
    [activeUlid, onNewAnalysis],
  )

  return (
    <div className={styles.drawer}>
      <div className={styles.header}>
        <span className={styles.title}>Historique</span>
        <IconButton
          icon="cross"
          theme="transparent-dark"
          size="nano"
          noBorder
          title="Fermer"
          onClick={onClose}
          testId="button-stats_assistant-history-close"
        />
      </div>

      <ConversationHistoryList
        activeUlid={activeUlid}
        onSelect={onSelect}
        onDeleted={handleDeleted}
      />
    </div>
  )
}
